import { Button, Stack, Text } from '@moda/om';
import React from 'react';
import MailIcon from '@moda/icons/mail-16';
import { SITE_FOOTER_LINKS_CONFIG } from '../../SiteFooterLinks/siteFooterLinksConfig';

export const SiteFooterMobileClientServices = () => {
  const clientServices = SITE_FOOTER_LINKS_CONFIG[0];

  return (
    <Stack className="SiteFooterMobileClientServices" space={4}>
      <Text treatment="eyebrow">{clientServices.name}</Text>

      <Stack space={2}>
        {clientServices.description?.map(descriptionLine => (
          <Text key={descriptionLine} treatment="body2">
            {descriptionLine}
          </Text>
        ))}
      </Stack>

      <Stack space={2}>
        {clientServices.links.map(link => (
          <Button href={link.href} key={link.label}>
            {link.href.includes('tel:') && 'Call '}

            {link.href.includes('mailto:') && <MailIcon />}

            {link.mobileLabel || link.label}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};
